import { Controller } from "@hotwired/stimulus"

// Shared opener for the appointment detail modal (rendered once in the
// goatleads layout). Open it from anywhere with:
//   window.dispatchEvent(new CustomEvent('appointment-detail:open', { detail: { id } }))
// Landing on any page with ?open_appointment=ID auto-opens it (used by the
// post-create/update redirects and old /appointments/:id bookmarks).
export default class extends Controller {
  static targets = ["frame"]
  static values = { baseUrl: String }

  connect() {
    this.initialFrameHTML = this.frameTarget.innerHTML
    this.boundHideForCache = () => this.modal && this.modal.hide()
    document.addEventListener("turbo:before-cache", this.boundHideForCache)

    const id = new URLSearchParams(window.location.search).get("open_appointment")
    if (id) this.open(id)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundHideForCache)
    if (this.modal) {
      this.modal.dispose()
      this.modal = null
    }
  }

  openFromEvent(event) {
    const id = event.detail && event.detail.id
    if (id) this.open(id)
  }

  open(id) {
    this.frameTarget.setAttribute("src", `${this.baseUrlValue}/${id}`)
    this.modal ||= new window.bootstrap.Modal(this.element)
    this.modal.show()
  }

  // Reset on close so the next open never flashes the previous appointment.
  clearFrame() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = this.initialFrameHTML
  }
}
